import { Pipe, PipeTransform } from '@angular/core';
import { PropertiesTag } from '@ui/shared/model';
import { sortTags } from '../../tag/tag-helper-functions';

@Pipe({
  name: 'appGetAssignablePropertyTags'
})
export class GetAssignablePropertyTagsPipe implements PipeTransform {
  transform(
    propertyTags: PropertiesTag[],
    propertiesTags: PropertiesTag[]
  ): PropertiesTag[] {
    return sortTags(
      propertiesTags?.filter(
        ({ id }) => !propertyTags?.some(tag => tag?.id === id)
      )
    );
  }
}
